import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import storageService from '@shared/storage/storageService';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-exchange-login',
  templateUrl: './exchange-login.component.html',
  styleUrls: ['./exchange-login.component.scss']
})
export class ExchangeLoginComponent implements OnInit {
  currentUser: any = {};
  public loginForm: FormGroup;
  showSpinner : boolean  = false;
  submitted: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ExchangeLoginComponent>,
    private auth: ApiCall,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      exchangeUsername: ["",[Validators.required,Validators.email]],
      exchangePassword: ["",[Validators.required]],
    });
  }

  get formControl() {
    return this.loginForm.controls;
  }

  onLogin() {
    this.showSpinner=true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.showSpinner=false;
      return
    }
    this.auth.doExchangeLogin(this.loginForm.value).subscribe(
      (res: any) => {
        if(res.status == "SUCCESS"){
          this.dialogRef.close();
          this.showSpinner=false;
          this.toastr.success(res.message);
        }else {
          this.showSpinner=false;
          this.toastr.error("Wrong credentials, Please try again.", "");
        }

      },
      (err: any) => {
        this.showSpinner=false;
        console.log("Something went wrong");
      }
    );
  }
  cancel(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
